exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px) {\n    .navbar .container {\n        width: 100%;\n    }\n}\n.navbar{border-bottom:1px solid #ddd; }\n.navbar.bg-faded{background:rgba(249,249,249,0.6);}\n.navbar.scrolled{background:rgba(249,249,249,1);}\n.navbar-brand h1{margin:0;}\n.navbar a.nav-link{color:rgba(0,0,0,1);}\n.navbar ul.navbar-nav li{/*font-size: 13px; font-weight: bold;*/ padding: 7px;}\n.navbar ul.navbar-nav li.active a, .navbar ul.navbar-nav li:hover a{color:#b50721;}\n.navbar ul.navbar-nav .btn{font-size: 14px; padding:5px 10px; margin-top:2px;}\n.navbar .fa{font-size: 20px;}\n.navbar .navbar-nav .nav-item.dropdown i.fa{font-size: 13px; padding-right:10px;}\n.navbar .navbar-nav .nav-item a.nav-link{margin-top:2px;}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/supplier/header/header.component.css
// module id = ../../../../../src/app/supplier/header/header.component.css
// module chunks = 39